import { createAction } from '@reduxjs/toolkit';

import { ReportAProblemPayload } from './types';

export const sendReportAProblemAction = createAction<ReportAProblemPayload>('reportAProblem/send');

export const reportAProblemFormWasShownAction = createAction('reportAProblem/formWasShown');
